import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const KNOWN = ['Olaparty', 'Trumeet'];
export const EMPTY_PLATFORMS = { picked: [], other: false, otherName: '' };

export const platformsFromList = (list = []) => {
    const known = (p) => KNOWN.find(k => k.toLowerCase() === String(p).trim().toLowerCase());
    const picked = list.map(known).filter(Boolean);
    const rest = list.filter(p => !known(p));
    return { picked, other: rest.length > 0, otherName: rest.join(', ') };
};

export const platformsToString = (v) => [...v.picked, ...(v.other ? v.otherName.split(',') : [])]
    .map(s => s.trim()).filter(Boolean).join(',');

export const platformLabel = (s) => String(s || '').split(',').map(x => {
    const t = x.trim();
    return KNOWN.find(k => k.toLowerCase() === t.toLowerCase()) || t;
}).filter(Boolean).join(', ');

export const PlatformPicker = ({ value, onChange, idPrefix = 'platform' }) => {
    const toggle = (name, on) => onChange({ ...value, picked: on ? [...value.picked, name] : value.picked.filter(p => p !== name) });
    return (
        <div className="space-y-1.5" data-testid={`${idPrefix}-picker`}>
            <Label className="text-xs">Platform (optional, tick any)</Label>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 min-h-9">
                {KNOWN.map(n => (
                    <label key={n} className="flex items-center gap-1.5 text-sm cursor-pointer">
                        <Checkbox checked={value.picked.includes(n)} onCheckedChange={c => toggle(n, !!c)} data-testid={`${idPrefix}-${n.toLowerCase()}`} /> {n}
                    </label>
                ))}
                <label className="flex items-center gap-1.5 text-sm cursor-pointer">
                    <Checkbox checked={value.other} onCheckedChange={c => onChange({ ...value, other: !!c })} data-testid={`${idPrefix}-other`} /> Other
                </label>
            </div>
            {value.other && <Input placeholder="Type platform name" maxLength={60} value={value.otherName} onChange={e => onChange({ ...value, otherName: e.target.value })} data-testid={`${idPrefix}-other-name`} />}
        </div>
    );
};

const d = (iso, endAdj = 0) => new Date(new Date(iso).getTime() - endAdj).toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' });
export const promoLiveLine = (p) => {
    if (!p.start_at) return 'Removed from homepage';
    const now = new Date();
    const state = new Date(p.end_at) <= now ? 'Ended' : new Date(p.start_at) > now ? 'Scheduled' : 'Live';
    return `${state} ${d(p.start_at)} → ${d(p.end_at, 1000)} · ${p.clicks || 0} clicks`;
};
